export default __webpack_public_path__ + "static/media/21-Safety.a55256da.svg";